import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { projectCategoriesStatus } from "../../redux/features/mastersSlice";

export const ProjectCategoryStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isActive}
                api={projectCategoriesStatus(params.categoryId)}
            />
        </div>
    );
};
